export const FilterTapEventMap = {
  bookstore: {
    SchoolYear: '書城篩選_學年度',
    EducationalSystem: '書城篩選_學制',
    Grade: '書城篩選_年級',
    Subject: '書城篩選_科目',
  },
  bookshelf: {
    SchoolYear: '書櫃篩選_學年度',
    EducationalSystem: '書櫃篩選_學制',
    Grade: '書櫃篩選_年級',
    Subject: '書櫃篩選_科目',
  },
};

// bookId 格式為 16 字元 hex 字串（例：/4984de42bf651b13）
const BOOK_ID_PATTERN = /^\/[a-f0-9]{16}$/i;

export const getModuleFromPath = (pathname) => {
  if (pathname === '/bookstore') return 'Bookstore';
  if (pathname === '/bookshelf' || pathname === '/qrcodelogin') return 'Bookshelf';
  if (pathname.startsWith('/bookForStudent/')) return 'Reader';
  if (BOOK_ID_PATTERN.test(pathname)) return 'Reader';
  return null;
};